import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataMappingService {

  constructor() { }

  getDateKey(): number {
    const localDate = new Date();

    const year = localDate.getFullYear();
    const month = String(localDate.getMonth() + 1).padStart(2, '0');
    const day = String(localDate.getDate()).padStart(2, '0');

    return Number(`${year}${month}${day}`);
  }
}
